export default "__VITE_ASSET__a8337d3c__"